import { BaseModel } from './BaseModel';

export interface InventoryLocation {
    id: number | string;
    short: string;
    long: string;
}

export interface InventoryNode {
    id: number | string;
    name: string;
    fqdn: string | null;
    location_id: number | string | null;
    location: string | null;
    servers: number;
}

export interface InventoryEgg {
    id: number | string;
    name: string;
}

export interface InventoryNest {
    id: number | string;
    name: string;
    eggs: InventoryEgg[];
}

export interface MigrationInventory {
    locations: InventoryLocation[];
    nodes: InventoryNode[];
    nests: InventoryNest[];
}

export interface MigrationPreflight {
    version: string | null;
    db_engine: string | null;
    decryptable: boolean;
    counts: Record<string, number>;
    conflicts: Record<string, number>;
    inventory?: MigrationInventory;
}

export type OutcomeCounts = Record<string, number>;

/**
 * NOTE: the API parser camelCases OBJECT keys but returns ARRAYS untouched —
 * elements of `nodes` (and the inventory lists) keep their snake_case keys,
 * while map-shaped attributes like `counts`/`preflight.counts` are camelCased.
 */
export interface MigrationNode {
    name: string;
    display_fqdn: string | null;
    location: string | null;
    /** True once the node's daemon has registered and bound a license. */
    adopted: boolean;
}

export class PanelMigration extends BaseModel {
    public id = '';
    public source = 'pterodactyl';
    public sourceVersion: string | null = null;
    public status = 'draft';
    public fqdn: string | null = null;
    public preflight: MigrationPreflight | null = null;
    public scope: Record<string, unknown> | null = null;
    public counts: Record<string, OutcomeCounts> | null = null;
    /** The live one-liner (include=command) — null once the token is spent. */
    public command: string | null = null;
    public notifiedUsers = false;
    public nodes: MigrationNode[] = [];
    public createdAt = '';
}
